/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum StartEndAdmChemoAliases {
  ACOMODATION_AUTOCOMPLETE = 'acomodation-autocomplete',
  ACOMODATION_FETCH = 'acomodation-fetch',
  ACOMODATION_FIELD = 'acomodation-field',
  ACOMODATION_MAPPER = 'acomodation-mapper',
  ACOMODATION_TEXT = 'acomodation-text',
  BUTTON_ARRIVE_REMOVE = 'button-arrive-remove',
  BUTTON_ARRIVED_INFORMATION = 'button-arrived-information',
  BUTTON_ENDADM_INFORMATION = 'button-endadm-information',
  BUTTON_ENDADM_REMOVE = 'button-endadm-remove',
  BUTTON_STARTADM_INFORMATION = 'button-startadm-information',
  BUTTON_STARTADM_REMOVE = 'button-startadm-remove',
  CONTEXTUAL_BAR_ARRIVED = 'contextual-bar-arrived',
  DATE_HOUR_ARRIVED = 'date-hour-arrived',
  DATE_HOUR_ARRIVED_INPUT = 'date-hour-arrived-input',
  DATE_HOUR_END_ADM = 'date-hour-end-adm',
  DATE_HOUR_END_ADM_INPUT = 'date-hour-end-adm-input',
  DATE_HOUR_START_ADM = 'date-hour-start-adm',
  DATE_HOUR_START_ADM_INPUT = 'date-hour-start-adm-input',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header ',
  MAIN_LAYOUT = 'main-layout',
  PANEL_ACOMODATION = 'panel-acomodation',
  PANEL_AND_ADM = 'panel-and-adm',
  PANEL_ARRIVED = 'panel-arrived',
  PANEL_INFORMATION = 'panel-information',
  PANEL_START_ADM = 'panel-start-adm',
}
export { StartEndAdmChemoAliases };
